export enum LocalStorageKeys {
  sidebarCollapsed = "sidebarCollapsed",

  skuGenerationMode = "skuGenerationMode",
  formula = "formula",
  variableSkuUsageCount = "variableSkuUsageCount",
  skuSettingsSynced = "BOXEM-sku-settings-synced",
  unfinishedFbmPolling = "BOXEM-unfinished-fbm-polling",

  user = "user",
  seller = "seller",

  preferredFNSKULabelPrinterName = "preferredFNSKULabelPrinterName",
  preferredBoxLabelPrinterName = "preferredBoxLabelPrinterName",
  fnskuLabelAspectRatio = "fnskuLabelAspectRatio",
  boxLabelAspectRatio = "boxLabelAspectRatio",

  salesSnapshotIntervals = "salesSnapshotIntervals",
  activeSnapshotIndex = "activeSnapshotIndex",

  useBoxemPrint = "useBoxemPrint",
  alwaysDownloadLabels = "alwaysDownloadLabels",

  autoPricingCollapsed = "autoPricingCollapsed",
  autoPrintFNSKUExpanded = "autoPrintFNSKUExpanded",
  metadataCollapsed = "metadataCollapsed",

  use30UpLabels = "use30UpLabels",

  preferredFNSKULabelSize = "preferredFNSKULabelSize",
  preferredBoxLabelSixe = "preferredBoxLabelSize",
  preferredFNSKULabelOrientation = "preferredFNSKULabelOrientation",

  // @NOTE(nick) we append a label kind to the end of these, so all localstoragekeys
  // beginning with these strings are reserved.
  preferredOtherLabelsPrinter = "preferredOtherLabelsPrinter",
  preferredOtherLabelsLabelSize = "preferredOtherLabelsLabelSize",
  customLabelConfig = "customLabelConfig",

  rolloWarning = "rolloWarning",

  fbaListings = "BOXEM-fba-listings",
  fbaListingsFlowStep = "BOXEM-fba-listings-flow-step",

  fbmListings = "BOXEM-fbm-listings",
  fbmListingsFlowStep = "BOXEM-fbm-listings-flow-step",

  tableStatePrefix = "BOXEM-table-state-",

  lastUsedDimensionsAndWeight = "lastUsedDimensionsAndWeight",

  ltlCancelWarningCreatePage = "ltlCancelWarningCreatePage",

  lastUsedShipperInformationContact = "lastUsedShipperInformationContact",

  profitOverviewCurrentPeriod = "profitOverviewCurrentPeriod",

  productResearchManualSearchCollapsed = "productResearchManualSearchCollapsed",
  productResearchAdvancedSearchCollapsed = "productResearchAdvancedSearchCollapsed",
  productResearchLastSearch = "productResearchLastSearch",
  productResearchProductFinderSavedSearches = "productResearchProductFinderSavedSearches",
}

export const getLocalStorageItem = <T>(key: string | LocalStorageKeys, defaultValue?: T): T | null => {
  try {
    const item = window.localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue ?? null;
  } catch (error) {
    console.error("Error retrieving date from localStorage:", error);
    return defaultValue ?? null;
  }
};

export const setLocalStorageItem = <T>(key: string | LocalStorageKeys, value: T): void => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error("Error setting data in localStorage:", error);
  }
};